import {getTestProps} from '@benchling/js-test-utils';
import {css} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import {makeNavbarBackgroundStyles} from 'nav/navbar/NavBarColor';
import {getTabStyles, navBarIconStyles} from 'nav/navbar/NavBarStyles';
import ClickOutWrapper from 'ui-library/ClickOutWrapper';
import {FloatingPlacement} from 'ui-library/floating-ui/FloatingConstants';
import Tooltip from 'ui-library/floating-ui/Tooltip';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

import * as SidepanelActions from '../sidepanel/SidepanelActions';

export interface LegacyCreateIconProps {
  createMenu: React.ReactNode;
  isCreateMenuOpen: boolean;
}

/**
 * Deprecated - use CreateIcon instead
 * @deprecated
 */
class LegacyCreateIcon extends React.Component<LegacyCreateIconProps> {
  _handleToggleCreateMenu = (): void => {
    if (this.props.isCreateMenuOpen) {
      SidepanelActions.closeCreateMenu();
    } else {
      SidepanelActions.openCreateMenu();
    }
  };

  _handleCloseCreateMenu = (): void => {
    if (this.props.isCreateMenuOpen) {
      SidepanelActions.closeCreateMenu();
    }
  };

  override render(): JSX.Element {
    return (
      <ClickOutWrapper shouldCloseOnInsideClick={false} onClickOut={this._handleCloseCreateMenu}>
        <Tooltip isDisabled={this.props.isCreateMenuOpen} placement={FloatingPlacement.RIGHT} text="Create">
          <div
            aria-haspopup="menu"
            aria-label="Create"
            className={classNames(
              css(getTabStyles(this.props.isCreateMenuOpen)),
              this.props.isCreateMenuOpen && 'open'
            )}
            onClick={this._handleToggleCreateMenu}
            role="button"
            style={makeNavbarBackgroundStyles()}
            tabIndex={0}
          >
            <div
              className={classNames(css(navBarIconStyles.iconWrapper), 'CreateIcon-inner')}
              {...getTestProps({
                component: 'CreateIcon',
                element: 'inner',
              })}
            >
              <div className={css(navBarIconStyles.inner)}>
                <BenchlingIcon icon="compose" className={css(navBarIconStyles.icon)} />
              </div>
            </div>
            {this.props.isCreateMenuOpen && (
              <div onClick={this._handleCloseCreateMenu} className="open">
                {this.props.createMenu}
              </div>
            )}
          </div>
        </Tooltip>
      </ClickOutWrapper>
    );
  }
}

export default LegacyCreateIcon;
